import { useGetCleanseFiles } from './generated/endpoint';
import { CleanseDataType, CleansingStatus } from './generated/models';
import type {
    CleanseFileResponse,
    GetCleanseFilesParams,
} from './generated/models';

export type { CleanseFileResponse };
export { CleanseDataType, CleansingStatus };

/** Databricks reports no progress, so an unfinished job is only observed by asking again. */
const POLL_INTERVAL_MS = 5000;

export const isCleansePending = (file: CleanseFileResponse): boolean =>
    file.cleansingStatus === CleansingStatus.NUMBER_0 ||
    file.cleansingStatus === CleansingStatus.NUMBER_1;

export const isCleansed = (file: CleanseFileResponse): boolean =>
    file.cleansingStatus === CleansingStatus.NUMBER_2;

export const cleansingStatusLabel = (file: CleanseFileResponse): string => {
    switch (file.cleansingStatus) {
        case CleansingStatus.NUMBER_0:
            return 'Awaiting cleansing';
        case CleansingStatus.NUMBER_1:
            return 'Cleansing';
        case CleansingStatus.NUMBER_2:
            return 'Cleansed';
        default:
            return 'Failed';
    }
};

/**
 * Lists cleanse jobs, polling only while at least one is still running so a finished
 * list settles to a single request.
 */
export const useCleanseFiles = (
    params: GetCleanseFilesParams,
    enabled = true
) =>
    useGetCleanseFiles(params, {
        query: {
            enabled,
            refetchInterval: (data) =>
                data?.some(isCleansePending) ? POLL_INTERVAL_MS : false,
        },
    });
